export class FavPage {
    public id: number;
    public employee_id: string;
    public page_id: number;
    public created_dt: Date;
    public created_by: string;
    constructor() {
        this.id = null;
        this.employee_id = '';
        this.page_id = null;
        this.created_dt = null;
        this.created_by = '';
    }
}
